// extracted by mini-css-extract-plugin
module.exports = {"SideBarBack":"SideBar_SideBarBack__2pean","SideBarFront":"SideBar_SideBarFront__3nsDQ","Title":"SideBar_Title__3cOHV","Lists":"SideBar_Lists__1axfF"};